import React from 'react'

const NoMatch = () => (
  <div>
    <p>Aucun widget à cette adresse : Vérifiez l'attribut "src"</p>
    <a
      href="https://developer.pictoaccess.fr/widget/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Plus d'informations
    </a>
  </div>
)

export default NoMatch
